import * as React from "react";
import {cx} from "emotion";

import "./office-create-tabs.scss";
import {consumeContext}          from "@Common/react/context";
import {cst, cstAssign}          from "@Common/react/chain-services";
import {Types}                   from "@Common/types";
import {addURLParameterToWindow} from "@Common/utils/add-url-parameter";

export const OfficeCreateTabs = ({step, onClick=undefined}) : ({step: Types.Common.React.UseState.UseStateNext<string>, onClick:()=>any}) => cst<{
    currentStep: number,
    tabs: Array<{
        tab: string;
        step: number;
        label: string;
    }>,
    themeScheme ?: any,
    createOfficeBrandedLogin ?: any,
}>(
    consumeContext("themeScheme"),
    cstAssign("createOfficeBrandedLogin", ({themeScheme}, next) => next(themeScheme?.type === "limitedGuest")),
    cstAssign("tabs",({createOfficeBrandedLogin}, next) => next(getTabs(createOfficeBrandedLogin))),
    cstAssign("currentStep",({tabs}, next) => next(tabs.find((t) => step.value === t.tab)['step'])),
    ({tabs, currentStep, createOfficeBrandedLogin}) => (
        <div className="office-create-tabs-i0e">
            {tabs.map((menuItem) => (
                <div {...{
                    className: cx("tab", {
                        active: step.value === menuItem.tab,
                        disabled: menuItem.step > currentStep,
                        threeTabs: createOfficeBrandedLogin
                    }),
                    key: menuItem.label,
                    "aria-label": menuItem.label,
                    "xd-qa-type": "tab",
                    "xd-qa-name": menuItem.label,
                    onClick: () => {
                        onClick && onClick();
                        if(menuItem.step < currentStep) {
                            addURLParameterToWindow({parameter: "step", value: menuItem.tab});
                            step.onChange(menuItem.tab);
                        }
                    },
                }}>
                    {menuItem.label}
                </div>
            ))}
    </div>
    )
);

export const controlInput = ''

const getTabs = (createOfficeBrandedLogin) => {
    if(createOfficeBrandedLogin) {
        return (
            [{
                tab: "general",
                step: 1,
                label: "General Info"
            },
            {
                tab: "office-address",
                step: 2,
                label: "Office Address"
            },
            {
                tab: "confirm",
                step: 3,
                label: "Confirm"
            }]
        )
    }
    return(
        [{
            tab: "general",
            step: 1,
            label: "General Info"
        },
        {
            tab: "login",
            step: 2,
            label: "Login Info"
        },
        {
            tab: "office-address",
            step: 3,
            label: "Office Address"
        },
        {
            tab: "confirm",
            step: 4,
            label: "Confirm"
        }]
    )

}
